import React, { useEffect, useState, useContext } from "react";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from '@mui/icons-material/Cancel';
import { GetUserList } from "../../utils/AxiosUtils";
import { SiteContext } from "../../utils/SiteContext";
import FilterButton from "../../components/FilterButton";
import { Button } from "@mui/material";


function CustomToolbar({ filter, setFilter, onAddUser }) {
  return (
    <GridToolbarContainer sx={{ justifyContent: "space-between", padding: "8px" }}>
      {/* Left side: Add User button */}
      <Button
        id="addUserBtn"
        variant="contained"
        color="primary"
        size="small"
        onClick={onAddUser}
      >
        Add User
      </Button>

      {/* Right side: Filter button */}
      <FilterButton id="filterBtn" filter={filter} setFilter={setFilter} />
    </GridToolbarContainer>
)}


export default function UserTable({ search, page, user, onAddUser }) {
  const [searchVal] = search;
  const [userVal, setUser] = user;
  const [filter, setFilter] = useState("All");
  const [dataVal, setData] = useState({ count: 0, results: [] });
  const { loading } = useContext(SiteContext);
  const [loadingVal, setLoading] = loading;

  useEffect(() => {
    setLoading(false);
    GetUserList(searchVal, filter, setData, page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingVal, filter]);

  const columns = [
    {
      field: "fullName",
      headerName: "User",
      flex: 1,
      valueGetter: (params) => `${params.row.first_name} ${params.row.last_name}`,
    },
    { field: "primary_company", headerName: "Company", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "last_active", headerName: "Last Active", flex: 1 },
    {
      field: "is_active",
      headerName: "Active",
      width: 50,
      renderCell: (params) => (params.value ? <CheckCircleIcon color="primary" /> : <CancelIcon color="error" />),
    },
  ];

  return (
    <Paper style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <DataGrid
        rows={dataVal.results}
        columns={columns}
        pageSize={10}
        loading={loadingVal}
        getRowId={(row) => row.id}
        rowHeight={35}
        onRowClick={(params) => setUser(params.id)}
        components={{
          Toolbar: () => <CustomToolbar filter={filter} setFilter={setFilter} onAddUser={onAddUser} />,
        }}
        sx={{
          "& .MuiDataGrid-row:hover": { backgroundColor: "#F0F0F0" },
          "& .MuiDataGrid-row.Mui-selected": { backgroundColor: "rgba(8,128,246,0.35)" },
          padding: 2,
        }}
      />
    </Paper>
  );
}